export const celebrities = [
    {
        invite: 'taukar',
        name: 'Karl-Erik Taukar',
        points: 12
    },
    {
        invite: 'martin',
        name: 'Martin Villig',
        points: 13
    },
    {
        invite: 'marko',
        name: 'Marko Oolo',
        points: 13
    },
    {
        invite: 'dominika',
        name: 'Dominika Pankova',
        points: 12
    },
    {
        invite: 'hensugusta',
        name: 'Hensugusta',
        points: 13
    },
    {
        invite: 'madis',
        name: 'Madis Müür',
        points: 16
    },
    {
        invite: 'markus',
        name: 'Markus Villig',
        points: 18
    },
    {
        invite: 'taavet',
        name: 'Taavet Hinrikus',
        points: 14
    },
    {
        invite: 'mattias',
        name: 'Mattias Naan',
        points: 15
    },
    {
        invite: 'mikk',
        name: 'Mikk Saar',
        points: 8
    },
    {
        invite: 'vips',
        name: 'Jüri Vips',
        points: 24
    },
];
